import { stripHtmlTags } from '@/lib/parse-html';
import Image from 'next/image';
import { FC } from 'react';

export type PullQuoteProps = {
  image?: string;
  quote: string;
  authorName: string;
  authorTitle: string;
  imageAlt?: string;
}



const PullQuote: FC<PullQuoteProps> = ({
  image,
  quote,
  authorName,
  authorTitle,
  imageAlt,
}) => {

  return (
    <div className="relative">
      <p className="relative text-p1 md:text-h3 font-500 max-md:tracking-[0px] text-blue-900 font-serif">
        {'\u201C'}
        {stripHtmlTags(quote)}
        {'\u201D'}
      </p>

      <div className="flex gap-1 items-center mt-4">
        {image && (
          <Image
            src={image}
            alt={imageAlt || authorName}
            width={24}
            height={24}
            className="w-6 h-6 rounded-full object-cover overflow-hidden"
          />
        )}
        <div className="flex gap-[0_16px] flex-wrap items-end">
          <span className={`${image ? 'max-md:w-full' : ''} text-p2`}>{authorName}</span>
          {authorTitle && (
            <span className="text-micro1 uppercase text-gray-500 mb-[2px]">{authorTitle}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default PullQuote;
